module.exports = __webpack_public_path__ + "static/media/ae-beat-image.84d8ea41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bonusView/ae-beat-image.png
// module id = 473
// module chunks = 0